// ─── Public Routes ────────────────────────────────────────────────────────────
export const ROUTES = {
  // Auth
  LOGIN:            '/login',
  AUTH_CALLBACK:    '/auth/callback',

  // Customer — booking flow
  BOOK:             '/book',
  BOOK_CATEGORY:    '/book/:category',
  BOOK_QUOTE:       '/book/:category/quote',
  BOOK_SCHEDULE:        '/book/schedule',
  BOOK_FINAL_PROPOSAL:  '/book/final-proposal',
  BOOK_CONTRACT:        '/book/contract/:proposalId',
  BOOK_PAYMENT:         '/book/payment/:proposalId',
  BOOK_CONFIRMED:   '/book/confirmed/:id',
  BOOK_TRACK:       '/book/track/:id',
  BOOK_PROGRESS:    '/book/progress/:id',
  BOOK_COMPLETE:    '/book/complete/:id',
  BOOK_REVIEW:      '/book/review/:id',
  BOOK_HISTORY:     '/book/history',

  // Worker
  WORKER_HOME:        '/worker',
  WORKER_JOB:         '/worker/job/:id',
  WORKER_PREPARE:     '/worker/job/:id/prepare',
  WORKER_ONSITE:      '/worker/job/:id/onsite',
  WORKER_ADDITIONAL:  '/worker/job/:id/additional',
  WORKER_COMPLETE:    '/worker/job/:id/complete',
  WORKER_EARNINGS:    '/worker/earnings',

  // Admin
  ADMIN:                '/admin',
  ADMIN_QUOTES:         '/admin/quotes',
  ADMIN_SITE_VISITS:    '/admin/site-visits',
  ADMIN_WORKERS:        '/admin/workers',
  ADMIN_RATES:          '/admin/rates',
  ADMIN_FINANCIALS:     '/admin/financials',
  ADMIN_CUSTOMERS:      '/admin/customers',

  // Customer — site visit
  BOOK_SITE_VISIT:      '/book/site-visit/:requestId',
}

// ─── Helper: build concrete paths with params ─────────────────────────────────
export const buildRoute = {
  bookSiteVisit: (requestId)  => `/book/site-visit/${requestId}`,
  bookContract:  (proposalId) => `/book/contract/${proposalId}`,
  bookPayment:   (proposalId) => `/book/payment/${proposalId}`,
  bookCategory:  (category) => `/book/${category}`,
  bookQuote:     (category) => `/book/${category}/quote`,
  bookConfirmed: (id)       => `/book/confirmed/${id}`,
  bookTrack:     (id)       => `/book/track/${id}`,
  bookProgress:  (id)       => `/book/progress/${id}`,
  bookComplete:  (id)       => `/book/complete/${id}`,
  bookReview:    (id)       => `/book/review/${id}`,
  workerJob:     (id)       => `/worker/job/${id}`,
  workerPrepare: (id)       => `/worker/job/${id}/prepare`,
  workerOnsite:  (id)       => `/worker/job/${id}/onsite`,
  workerAdditional: (id)   => `/worker/job/${id}/additional`,
  workerComplete: (id)     => `/worker/job/${id}/complete`,
}

// ─── Role-based default redirect after login ──────────────────────────────────
export const ROLE_HOME = {
  customer: ROUTES.BOOK,
  worker:   ROUTES.WORKER_HOME,
  admin:    ROUTES.ADMIN,
}
